import { render, staticRenderFns } from "./FairImage.vue?vue&type=template&id=8c8b861a&"
import script from "./FairImage.vue?vue&type=script&lang=js&"
export * from "./FairImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports